module.exports = __webpack_public_path__ + "img/metal_af@2x.47569b8d.png";